import { render, staticRenderFns } from "./CreateUserGroup.vue?vue&type=template&id=353e0eb6&scoped=true"
import script from "./CreateUserGroup.vue?vue&type=script&lang=js"
export * from "./CreateUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e0eb6",
  null
  
)

export default component.exports